import { HasIdNameDisplay } from "~/@shared/api-types/id-name-display"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

import { NewGradJob } from "../_types"

const PATH = "/new-grad-jobs/grouped"

export type GetNewGradJobsGrouped = GroupedRecruitment[]

export const fetchGetNewGradJobsGrouped = defineFetcher((): Promise<GetNewGradJobsGrouped> => {
  return GET(PATH)
})

export type GroupedRecruitment = HasIdNameDisplay & {
  data: Array<NewGradJob>
}
